import React, { useContext } from 'react';
import style from './Plan.module.scss';
import { AppContext } from '../../context/AppContext';
import { IItem, IOneTimePaymentItem, IPlan } from '../../model';
import Item from './Item';
import classNames from 'classnames';

interface IProps {
  plans: IPlan[];
  onePaymentItems: IOneTimePaymentItem[];
  isShowAll: boolean;
  showAll?: (state: boolean) => void;
}

const Plans = (
  {
    plans,
    showAll,
    onePaymentItems,
    isShowAll
  }: IProps
) => {
  const contextData = useContext(AppContext);
  const { sport, currentSubscriptions } = contextData || {};
  const items: IItem[] = [...plans, ...onePaymentItems];

  return <>
    <div className={classNames(style.plans__wrapper, {[style.remove_scroll__desktop]: sport === "Specials"}) }>
      <div className={style.plans}>
        {items.map(item => <Item key={item.plan_id} item={item} />)}
      </div>
    </div>
    {Object.keys(currentSubscriptions || {}).length && typeof showAll !== "undefined" ? <div className={style.text_center}>
       <button className={style.show_all} onClick={() => showAll?.(!isShowAll)}>
        {isShowAll ? "Hide Lower Plans" : "Show All Plans"}
      </button>
    </div> : ""}
  </>
};

export default Plans;
